import { useMemo } from 'react'
import { useCurrency } from '../../../contexts/CurrencyContext'
import styles from './Inventory.module.css'
import { computeInventoryRowDerived } from './inventoryRowDerived'
import type { InventoryProduct } from './inventoryTypes'

// Every money figure on a row is server-resolved in the store's currency (listedPrice /
// storePrices), so the row needs only the formatter — no exchange rates, no organisation
// currency to convert into.
export function useInventoryRowDerived(product: InventoryProduct) {
  const { formatPrice } = useCurrency()

  return useMemo(
    () => computeInventoryRowDerived(product, { formatPrice, styles }),
    [product, formatPrice],
  )
}
